export default {
  nav: {
    home: 'Home',
    spreadsheet: 'Spreadsheet',
    guides: 'Guides',
    shopping_guide: 'Shopping Guide',
    shipping: 'Shipping',
    qc: 'QC',
    reviews: 'Reviews',
    categories: 'Categories',
    language: 'Language',
  },
  hero: {
    title: 'AllChinaBuy Spreadsheet – Find Products, Sellers & Buying Resources',
    subtitle: 'Your AllChinaBuy Spreadsheet & Buying Resource Hub',
    description: 'Discover useful AllChinaBuy spreadsheet resources, product lists, seller information, QC guides, shipping tips and practical buying advice — organized in one easy-to-use resource hub.',
    cta_primary: 'Explore AllChinaBuy Spreadsheet',
    cta_secondary: 'Browse Buying Guides',
    trust: 'Independent resources • Updated content • Practical buying information',
  },
  categories: {
    title: 'Popular AllChinaBuy Spreadsheet Categories',
    subtitle: 'Browse product categories and find what you need faster',
    shoes: 'Shoes',
    hoodies: 'Hoodies/Sweaters',
    tshirts: 'T-Shirts',
    jackets: 'Jackets',
    pants: 'Pants/Shorts',
    headwear: 'Headwear',
    sets: 'Sets',
    underwear: 'Underwear/Underpants',
    jersey: 'Jersey',
    accessories: 'Accessories',
    bags: 'Bags',
    belts: 'Belts',
    perfumes: 'Perfumes',
    other: 'Other Stuff',
  },
  cta: {
    title: 'Ready to Start Shopping?',
    description: 'Visit our main website for the full AllChinaBuy spreadsheet experience and start finding products today.',
    button_main: 'AllChinaBuy Spreadsheet',
    button_buy: 'Buy It Now',
  },
  articles: {
    title: 'Latest AllChinaBuy Spreadsheet Guides',
    subtitle: 'Learn how to buy smarter with our comprehensive resources',
    read_more: 'Read More',
    article_1_title: 'AllChinaBuy Spreadsheet Complete Guide 2026',
    article_1_desc: 'Everything you need to know about using the AllChinaBuy spreadsheet to find products, compare sellers, and make informed purchasing decisions.',
    article_2_title: 'How to Read AllChinaBuy QC Photos',
    article_2_desc: 'A step-by-step guide to understanding quality control photos and checking product details before you buy.',
    article_3_title: 'AllChinaBuy Shipping Methods Compared',
    article_3_desc: 'Compare shipping options, costs, delivery times and tracking features to choose the best method for your needs.',
    article_4_title: 'Is AllChinaBuy Safe? A Complete Security Guide',
    article_4_desc: 'Learn about safety measures, payment protection, seller verification, and how to avoid common scams.',
    article_5_title: 'AllChinaBuy Review 2026',
    article_5_desc: 'An in-depth review of the AllChinaBuy ordering experience, warehouse service, quality control and shipping.',
    article_6_title: 'AllChinaBuy Shipping Cost Guide',
    article_6_desc: 'Understand shipping rates, methods, hidden costs and practical strategies to reduce your AllChinaBuy shipping expenses.',
    article_7_title: 'AllChinaBuy Warehouse Guide',
    article_7_desc: 'How the AllChinaBuy warehouse works, free storage periods, QC photos and consolidation explained.',
    article_8_title: 'AllChinaBuy Coupon & Discount Guide',
    article_8_desc: 'Learn how AllChinaBuy promotions work, where legitimate discounts come from and how to avoid fake coupons.',
    article_9_title: 'Is AllChinaBuy Legit?',
    article_9_desc: 'What makes AllChinaBuy a legitimate platform, where the real risks lie and how to protect yourself.',
    article_10_title: 'AllChinaBuy Seller Guide',
    article_10_desc: 'How to evaluate sellers, spot red flags and build a trusted shortlist for a better experience.',
    article_11_title: 'How to Find Products on AllChinaBuy',
    article_11_desc: 'Effective search strategies, filters and verification tips to find quality products faster.',
    article_12_title: 'AllChinaBuy Buying Guide',
    article_12_desc: 'A complete walkthrough of the AllChinaBuy buying process from your first order to final delivery.',
    article_13_title: 'AllChinaBuy Shipping Calculator Guide',
    article_13_desc: 'How to estimate shipping costs accurately and use the results to make smarter decisions.',
    article_14_title: 'Common AllChinaBuy Mistakes',
    article_14_desc: 'Avoid the most frequent mistakes new buyers make and shop with confidence from day one.',
  },
  features: {
    title: 'Why Use Our AllChinaBuy Spreadsheet Resources?',
    feature_1_title: 'Organized Product Lists',
    feature_1_desc: 'Find products across categories with structured spreadsheets that save you hours of searching.',
    feature_2_title: 'Seller Information',
    feature_2_desc: 'Access detailed seller data, ratings, and product ranges to make confident buying choices.',
    feature_3_title: 'QC & Quality Guides',
    feature_3_desc: 'Understand quality control processes and learn what to check before confirming orders.',
    feature_4_title: 'Shipping Resources',
    feature_4_desc: 'Compare shipping methods, costs, and delivery times to optimize your purchasing strategy.',
  },
  footer: {
    title: 'AllChinaBuy Spreadsheet Hub',
    description: 'Your independent resource for AllChinaBuy spreadsheet guides, product lists, and buying information.',
    links: 'Quick Links',
    resources: 'Resources',
    legal: 'Legal',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    disclaimer: 'Disclaimer',
    contact: 'Contact',
    copyright: '© 2026 AllChinaBuy Spreadsheet Hub. All rights reserved.',
    disclaimer_text: 'This website is an independent informational resource. Information can change and should be independently verified before making purchasing decisions.',
  },
  not_found: {
    title: 'Page Not Found',
    description: 'The page you are looking for does not exist. Return to the homepage to explore AllChinaBuy spreadsheet resources.',
    back_home: 'Back to Home',
  },
  seo: {
    meta_title: 'AllChinaBuy Spreadsheet – Products, Sellers, QC & Buying Guides',
    meta_description: 'Explore the latest AllChinaBuy spreadsheet, product resources, seller guides, QC tips, shipping information and buying guides. Find products faster and shop smarter.',
  },
  dropdown: {
    select_category: 'Select a Category',
    go: 'Go',
  },
  products: {
    title: 'Featured Products',
    subtitle: 'Explore curated products from our AllChinaBuy spreadsheet — click any item to view details and purchase on our main website.',
    view_all: 'View All',
  },
  faq: {
    title: 'Frequently Asked Questions',
    q1: 'What is the AllChinaBuy Spreadsheet?',
    a1: 'The AllChinaBuy spreadsheet is an organized resource that helps buyers find products, sellers, and buying information across multiple categories. It saves time by collecting useful links and product details in one place.',
    q2: 'Is AllChinaBuy safe to use?',
    a2: 'AllChinaBuy is a legitimate platform. However, as with any online marketplace, buyers should verify sellers, check QC photos, and use secure payment methods. Our guides help you shop safely.',
    q3: 'How do I find the best products?',
    a3: 'Use our category guides and spreadsheet resources to compare products across sellers. Read QC guides and check reviews before making purchases.',
    q4: 'What shipping methods are available?',
    a4: 'AllChinaBuy offers various shipping options. Check our shipping comparison guide to find the best method based on your location, budget, and delivery needs.',
  },
};